import { EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addSalaryComponents,
  loadAllSalaryComponents,
  updateSalaryComponent,
} from "../../redux/rtk/features/salaryComponent/salaryComponentSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import FormulaBuilder from "../../utils/formulaBuilder";

function CustomTable({ list, loading, onEdit }) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [formulaType, setFormulaType] = useState("flat");
console.log("list", list);

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "id",
      key: "id",
    },
    {
      id: 2,
      title: "Component Type",
      dataIndex: "componentType",
      key: "componentType",
    },
    {
      id: 3,
      title: "Component Name",
      dataIndex: "componentName",
      key: "componentName",
    },
    
    {
      id: 4,
      title: "Calculation Type",
      dataIndex: "calculationType",
      key: "calculationType",
    },
    {
      id: 5,
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (text ? text : "-"),
    },
    {
      id: 6,
      title: "Pro-rata basis",
      dataIndex: "proRata",
      key: "proRata",
      render: (text) => <Checkbox checked={text} disabled />,
    },
    {
      id: 7,
      title: "Taxable Component",
      dataIndex: "taxable",
      key: "taxable",
      render: (text) => <Checkbox checked={text} disabled />,
    },
    {
      id: 8,
      title: "Action",
      key: "action",
      render: (text, record) => (
        <UserPrivateComponent permission={"update-setting"}>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          >
            Edit
          </Button>
        </UserPrivateComponent>
      ),
    },
    {
      id: 9,
      title: "Formula Type",
      dataIndex: "formulaType",
      key: "formulaType",
      render: (text, record) => {
        if (text === "threshold") {
          return `Threshold (${record.thresholdAmount})`;
        } else if (text === "custom") {
          return "Custom Formula";
        } else {
          return "Flat Amount";
        }
      },
    }
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const addKeys = (arr) => {
    if (!Array.isArray(arr)) {
      return [];
    }
    return arr.map((i) => ({ ...i, key: i.id }));
  };

  return (
    <Card>
      <div className="text-center my-2 flex justify-between">
        <h5 className="department-list-title text-color-2 text-xl mb-2">
          Components List
        </h5>
      </div>
      <Table
        scroll={{ x: true }}
        loading={loading}
        columns={columnsToShow}
        dataSource={list ? addKeys(list) : []}
      />
    </Card>
  );
}

const SalaryComponents = ({ drawer }) => {
  const { Title } = Typography;
  const [loader, setLoader] = useState(false);
  const { list, loading } = useSelector((state) => state.salaryComponents);
  const [form] = Form.useForm();
  const [prorata, setProrata] = useState(false);
  const [taxable, setTaxable] = useState(false);
  const [editId, setEditId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadAllSalaryComponents());
  }, [dispatch]);

  const handleEdit = (record) => {
    form.setFieldsValue({
      componentType: record.componentType,
      componentName: record.componentName,
      calculationType: record.calculationType || 'flatAmount',
      amount: record.amount,
      formula: record.formula,
      payType: record.payType || 'fixed',
      proRata: record.proRata,
      taxable: record.taxable,
      isActive: record.isActive,
    });
    setProrata(record.proRata);
    setTaxable(record.taxable);
    setEditId(record.id);
  };

  const onFinish = async (values) => {
    setLoader(true);
    const salaryComponentData = {
      componentType: values.componentType,
      componentName: values.componentName,
      calculationType: values.calculationType,
      amount: values.calculationType === 'flatAmount' ? values.amount : null,
      formula: values.calculationType === 'customFormula' ? values.formula : null,
      payType: values.payType,
      proRata: prorata,
      taxable: taxable,
      isActive: values.isActive || false,
    };

    try {
      if (editId) {
        const resp = await dispatch(
          updateSalaryComponent({ values: salaryComponentData, id: editId })
        );
        if (resp.payload.message === "success") {
          dispatch(loadAllSalaryComponents());
          setEditId(null);
        } else {
          toast.error("Failed to update component");
        }
      } else {
        const resp = await dispatch(addSalaryComponents(salaryComponentData));
        if (resp.payload.message === "success") {
          toast.success("Component added successfully");
          dispatch(loadAllSalaryComponents());
        } else {
          toast.error("Failed to add component");
        }
      }
      form.resetFields();
      setProrata(false);
      setTaxable(false);
      setLoader(false);
    } catch (error) {
      toast.error("An error occurred");
      setLoader(false);
    }
  };

  const onFinishFailed = () => {
    toast.warning("Failed to process form");
    setLoader(false);
  };

  return (
    <Fragment>
      <UserPrivateComponent permission={"create-setting"}>
        <Row className="mr-top" justify={drawer ? "center" : "space-between"}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={drawer ? 22 : 16}
            xl={drawer ? 22 : 12}
            className="column-design border rounded card-custom"
          >
            <Title level={4} className="m-2 mt-5 mb-5 text-center">
              {editId ? "Update Salary Component" : "Add Salary Component"}
            </Title>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="salaryComponentForm"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 12 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                style={{ marginBottom: "5px" }}
                label="Component Type"
                name="componentType"
                rules={[{ required: true, message: "Please select the component type!" }]}
              >
                <Radio.Group>
                  <Radio value="Income">Income</Radio>
                  <Radio value="Deduction">Deduction</Radio>
                </Radio.Group>
              </Form.Item>
              
              <Form.Item
                style={{ marginBottom: "10px" }}
                label="Component Name"
                name="componentName"
                rules={[{ required: true, message: "Please input the component name!" }]}
              >
                <Input placeholder="HRA" />
              </Form.Item>
              
              {/* Replace calculation type & amount fields with FormulaBuilder */}
              <FormulaBuilder form={form} />
              
              {/* Pro-rata and Taxable fields remain the same */}
              <Form.Item
                style={{ marginBottom: "5px" }}
                label="Pro-rata basis"
                name="proRata"
                valuePropName="checked"
              >
                <Checkbox onChange={(e) => setProrata(e.target.checked)} />
              </Form.Item>
              
              <Form.Item
                style={{ marginBottom: "20px" }}
                label="Taxable Component"
                name="taxable"
                valuePropName="checked"
              >
                <Checkbox onChange={(e) => setTaxable(e.target.checked)} />
              </Form.Item>
              
              <Form.Item
                style={{ marginBottom: "10px" }}
                wrapperCol={{ offset: 8, span: 12 }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  block
                  loading={loader}
                >
                  {editId ? "Update Component" : "Add Component"}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </UserPrivateComponent>
      <hr />
      <UserPrivateComponent permission={"readAll-setting"}>
        <CustomTable list={list} loading={loading} onEdit={handleEdit} />
      </UserPrivateComponent>
    </Fragment>
  );
};

export default SalaryComponents;

// const SalaryComponents = ({ drawer }) => {
//   const { Title } = Typography;
//   const { Option } = Select;
//   const [loader, setLoader] = useState(false);
//   const { list, loading } = useSelector((state) => state.salaryComponents);
//   const [form] = Form.useForm();
//   const [calculationType, setCalculationType] = useState("Amount");
//   const [prorata, setProrata] = useState(false);
//   const [taxable, setTaxable] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const dispatch = useDispatch();
//   const [formulaType, setFormulaType] = useState("flat"); 
//   useEffect(() => {
//     dispatch(loadAllSalaryComponents());
//   }, [dispatch]);

//   const handleEdit = (record) => {
//     form.setFieldsValue({
//       componentType: record.componentType,
//       componentName: record.componentName,
//       calculationType: record.calculationType,
//       amount: record.amount,
//       proRata: record.proRata,
//       taxable: record.taxable,
//     });
//     setCalculationType(record.calculationType);
//     setProrata(record.proRata);
//     setTaxable(record.taxable);
//     setEditId(record.id);
//   };

//   const onFinish = async (values) => {
//     setLoader(true);
//     const salaryComponentData = {
//       componentType: values.componentType,
//       componentName: values.componentName,
//       calculationType: values.calculationType,
//       amount: values.amount || null,
//       proRata: prorata,
//       taxable: taxable,
//       formulaType: values.formulaType || "flat",
//   thresholdAmount: values.thresholdAmount,
//   belowThresholdAction: values.belowThresholdAction,
//   aboveThresholdAction: values.aboveThresholdAction,
//   customFormula: values.customFormula,
//     };

//     try {
//       if (editId) {
//         const resp = await dispatch(
//           updateSalaryComponent({ values: salaryComponentData, id: editId })
//         );
//         if (resp.payload.message === "success") {
//           dispatch(loadAllSalaryComponents());
//           setEditId(null);
//         } else {
//           toast.error("Failed to update component");
//         }
//       } else {
//         const resp = await dispatch(addSalaryComponents(salaryComponentData));
//         if (resp.payload.message === "success") {
//           toast.success("Component added successfully");
//           dispatch(loadAllSalaryComponents());
//         } else {
//           toast.error("Failed to add component");
//         }
//       }
//       form.resetFields();
//       setCalculationType("Amount");
//       setProrata(false);
//       setTaxable(false);
//       setLoader(false);
//     } catch (error) {
//       toast.error("An error occurred");
//       setLoader(false);
//     }
//   };

//   const onFinishFailed = () => {
//     toast.warning("Failed to process form");
//     setLoader(false);
//   };

//   return (
//     <Fragment>
//       <UserPrivateComponent permission={"create-setting"}>
//         <Row className="mr-top" justify={drawer ? "center" : "space-between"}>
//           <Col
//             xs={24}
//             sm={24}
//             md={24}
//             lg={drawer ? 22 : 16}
//             xl={drawer ? 22 : 12}
//             className="column-design border rounded card-custom"
//           >
//             <Title level={4} className="m-2 mt-5 mb-5 text-center">
//               {editId ? "Update Salary Component" : "Add Salary Component"}
//             </Title>
//             <Form
//               form={form}
//               style={{ marginBottom: "40px" }}
//               name="salaryComponentForm"
//               labelCol={{ span: 8 }}
//               wrapperCol={{ span: 12 }}
//               exceptions={['onReset']}
//               onFinish={onFinish}
//               onFinishFailed={onFinishFailed}
//               autoComplete="off"
//             >
//               <Form.Item
//                 style={{ marginBottom: "5px" }}
//                 label="Component Type"
//                 name="componentType"
//                 rules={[{ required: true, message: "Please select the component type!" }]}
//               >
//                 <Radio.Group>
//                   <Radio value="Income">Income</Radio>
//                   <Radio value="Deduction">Deduction</Radio>
//                 </Radio.Group>
//               </Form.Item>
//               <Form.Item
//                 style={{ marginBottom: "10px" }}
//                 label="Component Name"
//                 name="componentName"
//                 rules={[{ required: true, message: "Please input the component name!" }]}
//               >
//                 <Input placeholder="HRA" />
//               </Form.Item>
            
// <Form.Item
//   label="Formula Type"
//   name="formulaType"
//   rules={[{ required: true, message: "Please select formula type" }]}
// >
//   <Select 
//     onChange={(value) => setFormulaType(value)}
//     placeholder="Select formula type"
//   >
//     <Option value="flat">Flat Amount</Option>
//     <Option value="threshold">Threshold Based</Option>
//     <Option value="custom">Custom Formula</Option>
//   </Select>
// </Form.Item>

// {formulaType === "threshold" && (
//   <>
//     <Form.Item
//       label="Threshold Amount"
//       name="thresholdAmount"
//       rules={[{ required: true, message: "Please enter threshold amount" }]}
//     >
//       <InputNumber placeholder="e.g. 15000" min={0} />
//     </Form.Item>
//     <Form.Item
//       label="Below Threshold"
//       name="belowThresholdAction"
//       rules={[{ required: true }]}
//     >
//       <Select placeholder="Select action for below threshold">
//         <Option value="useSalary">Use Employee's Salary</Option>
//         <Option value="usePercentage">Use Percentage of Salary</Option>
//         <Option value="useFixed">Use Fixed Amount</Option>
//       </Select>
//     </Form.Item>
//     <Form.Item
//       label="Above Threshold"
//       name="aboveThresholdAction"
//       rules={[{ required: true }]}
//     >
//       <Select placeholder="Select action for above threshold">
//         <Option value="useInput">Use Input Amount</Option>
//         <Option value="usePercentage">Use Percentage of Salary</Option>
//         <Option value="useFixed">Use Fixed Amount</Option>
//       </Select>
//     </Form.Item>
//   </>
// )}

// {formulaType === "custom" && (
//   <Form.Item
//     label="Custom Formula"
//     name="customFormula"
//     rules={[{ required: true, message: "Please enter custom formula" }]}
//   >
//     <Input.TextArea 
//       placeholder="e.g. salary < 15000 ? salary : amount" 
//       rows={3}
//     />
//     <div className="text-xs text-gray-500 mt-1">
//       Use variables: salary, amount, basic, etc.
//     </div>
//   </Form.Item>
// )}
//               <Form.Item
//                 style={{ marginBottom: "10px" }}
//                 label="Calculation Type"
//                 name="calculationType"
//                 rules={[{ required: true, message: "Please select the Calculation type!" }]}
//               >
//                 <Select onChange={(value) => setCalculationType(value)}>
//                   <Option value="Amount">Amount</Option>
//                   <Option value="% of Basic">Percentage of Basic</Option>
//                   <Option value="% of Amount">Percentage of Amount</Option>
//                 </Select>
//               </Form.Item>
//               {calculationType === "% of Amount" && (
//                 <Form.Item
//                   style={{ marginBottom: "10px" }}
//                   label="Amount"
//                   name="amount"
//                   rules={[{ required: true, message: "Please input the amount!" }]}
//                 >
//                   <InputNumber placeholder="Enter amount" min={0} />
//                 </Form.Item>
//               )}
//               <Form.Item
//                 style={{ marginBottom: "5px" }}
//                 label={
//                   <span>
//                     Pro-rata basis
//                     <Tooltip title="Pro-rata basis means the calculation is based on a proportionate basis.">
//                       <InfoCircleOutlined style={{ marginLeft: "5px" }} />
//                     </Tooltip>
//                   </span>
//                 }
//                 name="proRata"
//                 valuePropName="checked"
//               >
//                 <Checkbox onChange={(e) => setProrata(e.target.checked)} />
//               </Form.Item>
//               <Form.Item
//                 style={{ marginBottom: "20px" }}
//                 label="Taxable Component"
//                 name="taxable"
//                 valuePropName="checked"
//               >
//                 <Checkbox onChange={(e) => setTaxable(e.target.checked)} />
//               </Form.Item>
//               <Form.Item
//                 style={{ marginBottom: "10px" }}
//                 wrapperCol={{ offset: 8, span: 12 }}
//               >
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   size="large"
//                   block
//                   loading={loader}
//                 >
//                   {editId ? "Update Component" : "Add Component"}
//                 </Button>
//               </Form.Item>
//             </Form>
//           </Col>
//         </Row>
//       </UserPrivateComponent>
//       <hr />
//       <UserPrivateComponent permission={"readAll-setting"}>
//         <CustomTable list={list} loading={loading} onEdit={handleEdit} />
//       </UserPrivateComponent>
//     </Fragment>
//   );
// };

// export default SalaryComponents;